//#region src/bite_log_verifone_point_cloud_event.ts
var BiteLogVerifonePointCloudEvent = /* @__PURE__ */ function(BiteLogVerifonePointCloudEvent) {
	BiteLogVerifonePointCloudEvent[BiteLogVerifonePointCloudEvent["TerminalDisconnected"] = 5] = "TerminalDisconnected";
	return BiteLogVerifonePointCloudEvent;
}(BiteLogVerifonePointCloudEvent || {});
//#endregion
export { BiteLogVerifonePointCloudEvent };

//# sourceMappingURL=bite_log_verifone_point_cloud_event.js.map